import { render } from "./NavigationMobileFooter.vue?vue&type=template&id=2e2eb625"
import script from "./NavigationMobileFooter.vue?vue&type=script&lang=js"
export * from "./NavigationMobileFooter.vue?vue&type=script&lang=js"

import "./NavigationMobileFooter.vue?vue&type=style&index=0&id=2e2eb625&lang=scss"

import exportComponent from "C:\\Users\\chervinskii_mk\\Documents\\ORIS\\Repositories\\site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__